













































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import SupplierBrandSelector from '@/components/dackpartner/SupplierBrandSelector.vue'
import DiameterTable from '@/components/dackpartner/DiameterTable.vue'

@Component({
  components: {
    SupplierBrandSelector,
    DiameterTable,
  },
})
export default class AmountConfiguration extends Vue {
  @Prop({ required: true }) configuration!: any
  @Prop({ required: true }) availableSuppliers!: any[]
  @Prop({ default: false }) loadingSuppliers!: boolean
  @Prop({ default: false }) readonly!: boolean

  private onSupplierChange(index: number, supplierId: string | null): void {
    const config = this.configuration.suppliers[index]
    config.supplier = supplierId
    if (!supplierId) {
      config.brand = null
    }
    this.$emit('supplier-change', index, supplierId)
  }

  private onBrandChange(index: number, brandId: string | null): void {
    this.configuration.suppliers[index].brand = brandId
    this.$emit('brand-change', index, brandId)
  }

  private addSupplierConfig(): void {
    this.configuration.suppliers.push({
      supplier: null,
      brand: null,
      discount_percent: 0,
      profit_percent: 0,
      profit_amount: 0,
      availableBrands: [],
      loadingBrands: false,
      brandSearchQuery: '',
    })
  }

  private removeSupplierConfig(index: number): void {
    if (this.configuration.suppliers.length > 1) {
      this.configuration.suppliers.splice(index, 1)
    }
  }

  private getDiameterValue(vehicleType: string, diameter: number): number {
    const config = (this.configuration as any)[vehicleType]
    if (!config) return 0
    const item = config.find((item: any) => item.diameter === diameter)
    return item ? item.amount : 0
  }

  private updateDiameterValue(vehicleType: string, diameter: number, value: string | number): void {
    const config = (this.configuration as any)[vehicleType]
    if (!config) return
    const item = config.find((item: any) => item.diameter === diameter)
    if (item) {
      item.amount = typeof value === 'string' ? parseFloat(value) || 0 : value
    }
  }

  private get discountRules(): Array<(v: any) => boolean | string> {
    return [
      (v: any) => (v !== null && v !== undefined && v !== '') || this.$t('Discount percentage is required'),
      (v: any) => v >= 0 || this.$t('Discount percentage must be greater than or equal to 0'),
    ]
  }

  private get profitPercentRules(): Array<(v: any) => boolean | string> {
    return [
      (v: any) => (v !== null && v !== undefined && v !== '') || this.$t('Profit percentage is required'),
      (v: any) => v >= 0 || this.$t('Profit percentage must be greater than or equal to 0'),
    ]
  }

  private get profitAmountRules(): Array<(v: any) => boolean | string> {
    return [
      (v: any) => (v !== null && v !== undefined && v !== '') || this.$t('Profit amount is required'),
      (v: any) => v >= 0 || this.$t('Profit amount must be greater than or equal to 0'),
    ]
  }

  private get diameterAmountRules(): Array<(v: any) => boolean | string> {
    return [
      (v: any) => (v !== null && v !== undefined && v !== '') || this.$t('Diameter amount is required'),
      (v: any) => v >= 0 || this.$t('Diameter amount must be greater than or equal to 0'),
    ]
  }

  private getUsedSupplierBrands(currentIndex: number): Array<{ supplier: number; brand: number }> {
    return this.configuration.suppliers
      .map((config: any, index: number) => {
        // Exclude current index to allow the current combination to remain selected
        if (index === currentIndex) return null
        
        // Only include if both supplier and brand are selected
        if (config.supplier && config.brand) {
          return { supplier: config.supplier, brand: config.brand }
        }
        return null
      })
      .filter((combination: any) => combination !== null)
  }

  public validateForms(): boolean {
    let isValid = true
    
    // Validate amount form
    if (this.$refs.amountForm) {
      const amountFormValid = (this.$refs.amountForm as any).validate()
      isValid = isValid && amountFormValid
    }
    
    // Validate diameter form
    if (this.$refs.diameterForm) {
      const diameterFormValid = (this.$refs.diameterForm as any).validate()
      isValid = isValid && diameterFormValid
    }
    
    return isValid
  }
}
